import axios from "./axios";
import { setHeaders } from "./baseApi";
import { apiPaths } from "./baseApi";

/**
 * @param {string} [context] - Contexte facultatif
 * @returns {Promise<any>}
 */

export const getAllEvaluationByEvaluationPeriod = async (
  id_evaluationPeriod,
  context,
) => {
  const response = await axios.get(
    apiPaths.baseUrl +
      `/api/evaluation/evaluationByPeriod/${id_evaluationPeriod}`,
    { headers: setHeaders(context) },
  );
  return response.data;
};

export const getAllEvaluationByPeriodAndLevel = async (
  id_level,
  id_evaluationPeriod,
  context,
) => {
  const response = await axios.get(
    apiPaths.baseUrl +
      `/api/evaluation/evaluationByLevel/${id_level}/${id_evaluationPeriod}`,
    { headers: setHeaders(context) },
  );
  return response.data;
};

export const getEvaluationById = async (id_evaluation, context) => {
  const response = await axios.get(
    apiPaths.baseUrl + `/api/evaluation/getOne/${id_evaluation}`,
    { headers: setHeaders(context) },
  );
  return response.data;
};

export const getAllEvaluation = async (context) => {
  const response = await axios.get(apiPaths.baseUrl + `/api/evaluation/all`, {
    headers: setHeaders(context),
  });
  return response.data;
};

export const getAllEvaluationByAcademicYear = async (
  id_academicYear,
  context,
) => {
  const response = await axios.get(
    apiPaths.baseUrl + `/api/evaluation/evaluationByYear/${id_academicYear}`,
    { headers: setHeaders(context) },
  );
  return response.data;
};

export const createEvaluation = async (payload, context) => {
  const response = await axios.post(
    apiPaths.baseUrl + `/api/evaluation/create`,
    payload,
    { headers: setHeaders(context) },
  );
  return response.data;
};

export const updateEvaluation = async (id, id_level, payload, context) => {
  const response = await axios.put(
    apiPaths.baseUrl + `/api/evaluation/update/${id}/${id_level}`,
    payload,
    { headers: setHeaders(context) },
  );
  return response.data;
};

export const deleteEvaluation = async (id_evaluation, context) => {
  const response = await axios.delete(
    apiPaths.baseUrl + `/api/evaluation/delete/${id_evaluation}`,
    { headers: setHeaders(context) },
  );
  return response.data;
};
